import React, { useState } from "react";

export const ColorLegendHelper: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div style={{ position: "fixed", bottom: "20px", right: "20px", zIndex: 9999 }}>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            bottom: "50px",
            right: "0",
            background: "var(--color-panel-bg)",
            border: "1px solid var(--color-panel-border)",
            borderRadius: "var(--border-radius-md)",
            padding: "16px",
            width: "280px",
            boxShadow: "var(--shadow-card)",
            color: "var(--color-text-primary)",
            animation: "fadeIn 0.2s ease",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "12px",
            }}
          >
            <h3 style={{ margin: 0, fontSize: "var(--text-md)", fontWeight: "bold" }}>
              Significado de Colores
            </h3>
            <button
              onClick={() => setIsOpen(false)}
              style={{
                background: "none",
                border: "none",
                color: "var(--color-text-secondary)",
                cursor: "pointer",
              }}
            >
              <i className="bx bx-x" style={{ fontSize: "1.2rem" }}></i>
            </button>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              fontSize: "var(--text-sm)",
            }}
          >
            <div>
              <div
                style={{
                  fontWeight: "bold",
                  marginBottom: "6px",
                  color: "var(--color-text-secondary)",
                }}
              >
                Tipos de Datos
              </div>
              <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                <LegendItem color="var(--color-data-rundown)" label="Rundown" />
                <LegendItem color="var(--color-data-event)" label="Evento" />
                <LegendItem color="var(--color-data-log)" label="Log" />
                <LegendItem color="var(--color-data-transcript)" label="Transcript" />
                <LegendItem color="var(--color-data-story)" label="OTF" />
              </div>
            </div>
          </div>
        </div>
      )}

      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          background: "var(--color-accent-primary)",
          color: "white",
          border: "none",
          boxShadow: "0 2px 10px rgba(247, 45, 96, 0.4)",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "1.5rem",
          transition: "transform 0.2s",
          transform: isOpen ? "scale(1.1)" : "scale(1)",
        }}
        title="Ayuda de colores"
      >
        <i className="bx bx-question-mark"></i>
      </button>
    </div>
  );
};

const LegendItem = ({ color, label }: { color: string; label: string }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    <div style={{ width: "12px", height: "12px", borderRadius: "50%", background: color }}></div>
    <span>{label}</span>
  </div>
);
